module.exports = __webpack_public_path__ + "static/media/Sun Wukong.34e3e91b.png";